import React, { Component } from "react";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import { UISref } from "@uirouter/react";
import { List, ListItem } from "material-ui/List";
import Divider from "material-ui/Divider";
import Subheader from "material-ui/Subheader";
import { Avatar, If } from "components/support";
import { flatMap } from "util";

import style from "./style";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./sidebar.css";

class SidebarView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyName: ""
    };
  }

  prioritizedChildren = items => {
    const { currentUser } = this.props.viewModel;

    return items
      .filter(item => {
        if (currentUser && Object.keys(currentUser).length > 0) {
          const context = { user: currentUser, company: currentUser.company };
          return item.authorization ? item.authorization(context) : true;
        } else {
          return false;
        }
      })
      .map((item, index) => ({ value: item, priority: item.priority || index }))
      .sort((a, b) => a.priority - b.priority)
      .map(item => item.value);
  };

  navigationTreeItem = (item, depth = 0) => {
    if (!!item.custom) {
      return <item.custom key={item.name} />;
    }

    if (!!item.subheader) {
      let itemGroup = [
        <Divider key={`divider/${item.name}`} />,
        <Subheader key={item.name} className="sidebar__menu-header">
          {item.name}
        </Subheader>
      ];

      if (!!item.children) {
        const children = this.prioritizedChildren(item.children);
        if (children.length === 0) {
          return [];
        }
        itemGroup = itemGroup.concat(
          children.map(child => this.navigationTreeItem(child, depth))
        );
      }

      return itemGroup;
    }

    const props = {
      primaryText: item.name,
      primaryTogglesNestedList: true,
      className: "sidebar__menu-item"
    };

    if (!!item.children && item.children.length > 0) {
      const children = this.prioritizedChildren(item.children);

      if (children.length === 0) {
        return null;
      }

      props.nestedItems = children.map(child =>
        this.navigationTreeItem(child, depth + 1)
      );
    }

    if (!!item.href) {
      props.href = item.href;
    }

    if (!!item.state) {
      return (
        <UISref
          key={item.name}
          to={item.state}
          params={item.stateParams}
          className={item.hasDivider ? "line" : ""}
        >
          <ListItem {...props} nestedLevel={depth} />
        </UISref>
      );
    }

    return [
      <ListItem key={item.name} {...props} />,
      <Divider key={`divider/${item.name}`} />
    ];
  };

  getCompanyName(currentUser) {
    const expectedLength = 40;
    const companyName = currentUser.company ? currentUser.company.slug : false;

    if (companyName) {
      if (companyName.length > expectedLength) {
        return `${companyName.substr(0, expectedLength)}...`;
      }
      return companyName;
    }

    return "";
  }

  render() {
    const { presenter, viewModel } = this.props;
    const { navigationTree, visible, currentUser } = viewModel;
    const companyName = this.getCompanyName(currentUser);

    return (
      <div className={`sidebar sidebar--${visible ? "visible" : "hidden"}`}>
        <div
          style={{
            height: "calc(100vh - 60px)",
            width: "100%",
            overflow: "hidden"
          }}
        >
          <div style={style.avatar}>
            <Avatar name={companyName} style={{ marginRight: 0 }} />
            <p className="company--name">{companyName}</p>
          </div>
          <PerfectScrollbar>
            <List style={{ padding: "0" }}>
              {flatMap(this.prioritizedChildren(navigationTree), item =>
                this.navigationTreeItem(item)
              )}

              <ListItem
                primaryTogglesNestedList
                primaryText="Sistema"
                className="sidebar__menu-item"
                nestedItems={[
                  <ListItem
                    primaryText="Sair"
                    key="logout"
                    className="sidebar__menu-item"
                    onTouchTap={() => presenter.onSignOut()}
                  />
                ]}
              />

              <Divider />

              <If test={process.env.REACT_APP_WHITELABEL_NAME === "PDVEND"}>
                <ListItem
                  primaryText="Ajuda"
                  key="help"
                  className="sidebar__menu-item"
                  target="_blank"
                  component="a"
                  href="https://ajuda.nexaas.com"
                />
              </If>
            </List>
          </PerfectScrollbar>
        </div>
      </div>
    );
  }
}

SidebarView.propTypes = {
  presenter: PropTypes.shape({
    setView: PropTypes.func
  })
};

export default SidebarView;



// WEBPACK FOOTER //
// ./src/components/support/sidebar/view.jsx